import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as Icon from "@phosphor-icons/react";
import Profile from "../../auth/Profile";
import RightPanel from "../../helpers/RightPanel";
import PulseLoader from "react-spinners/PulseLoader";
import { useDispatch, useSelector } from "react-redux";
import Search from "./Search";
import useDeviceType from "../../helpers/GetDevice";
import CartDrawer from "../../cart/CartDrawer";
import { openLoginModal } from "../../../slices/authSlice";
import SearchDropdown from "./SearchDropdown";
import { updateItemQuantityServer } from "../../../slices/cart";
import ButtonC from "../../../theme/ButtonC";
import {
  removeItemFromServer,
  fetchCartFromServer,
  updateLocalCart,
} from "../../../slices/cart";
import SessionService from "../../../services/SessionService";
import MobileSearchDrawer from "./MobileSearchDrawer";

const CART_ACTION = {
  ADD: "ADD",
  SET_QUANTITY: "SET_QUANTITY",
  REMOVE: "REMOVE",
};

export default function Header() {
  let navigate = useNavigate();
  const location = useLocation();
  const deviceType = useDeviceType();
  const dispatch = useDispatch();
const [openMobileSearch, setOpenMobileSearch] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(SessionService.isLoggedIn);

  const { items: cartItems } = useSelector((state) => state.cart);
  const [cart, setCart] = useState([]);

  useEffect(() => {
    setCart(cartItems);
  }, [cartItems]);

  const [favourites, setFavourites] = useState({ favouriteItems: [] });

  const [showRightMenu, setShowRightMenu] = useState(false);
  const [loaderBar, setLoaderBar] = useState(true);
  const [topPadding, setTopPadding] = useState("90px");

  useEffect(() => {
    if (location.pathname === "/") {
      setLoaderBar(false);
    } else {
      setLoaderBar(true);
    }
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setTopPadding("90px");
      } else {
        setTopPadding("80px");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // initial
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const handleUpdateItem = (payload) => {
    if (isLoggedIn) {
      dispatch(updateItemQuantityServer({ ...payload, isLoggedIn }));
      setTimeout(() => dispatch(fetchCartFromServer()));
    } else {
      const action =
        payload.quantity > 0 ? CART_ACTION.SET_QUANTITY : CART_ACTION.REMOVE;
      const itemPayload = {
        product: payload.product,
        variant: payload.variant,
        quantity: payload.quantity,
      };
      dispatch(updateLocalCart({ action, itemPayload }));
    }
  };

  const handleRemoveItem = (id) => {
    dispatch(removeItemFromServer(id));
    setTimeout(() => dispatch(fetchCartFromServer()), 500);
  };

  const handleCheckout = () => {
    if (!isLoggedIn) {
      dispatch(openLoginModal());
      return;
    }

    navigate(`/checkout`);
    setShowRightMenu(false);
    setIsCartOpen(false);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <div className="row">
        <div className="col-12 p-0 m-0">
          <header className="header">
            <div className="header-inner">
              <div className="container-fluid pe-0">
                <div className="d-flex align-items-center justify-content-between">

                  <div className="header_left_part d-flex align-items-center">
                    <div className="logo">
                      <a href="/" style={{ alignContent: "center" }}>
                        <img
                          src={require("../../../assets/Images/AeliteZLogoWriteRed.gif")}
                          alt="logo"
                          style={{ width: "40px", height: "30px" }}
                        />
                        <img
                          src={require("../../../assets/Images/Logoname.png")}
                          alt="logo"
                          style={{ width: "100px", height: "20px", marginTop: "3px" }}
                        />
                      </a>
                    </div>
                  </div>

                  <div className="header_center_part d-none d-xl-block">
                    <div className="mainnav">
                      <ul className="main-menu">
                        <li><a href="/">Home</a></li>

                        <li className="menu-item-has-children">
                          <a href="#">Women</a>
                          <ul className="sub-menu" data-lenis-prevent>
                            <li><a href="/shop?category=Maternity Wear">Maternity Wear</a></li>
                            <li><a href="/shop?category=Lounge Wear">Lounge Wear</a></li>
                            <li><a href="/shop?category=Palazzo Pants">Palazzo Pants</a></li>
                            <li><a href="/shop?category=CO-ORD Set">CO-ORD Set</a></li>
                            <li><a href="/shop?category=Jeggings">Jeggings</a></li>
                            <li><a href="/shop?category=Kurthis">Kurthis</a></li>
                            <li><a href="/shop?category=Ladies Tops">Ladies Tops</a></li>
                            <li><a href="/shop?category=Elegant maxis">Elegant Maxis</a></li>
                          </ul>
                        </li>

                        <li><a href="/shop?category=Men">Men</a></li>
                        <li><a href="/shop?category=Kids">Kids</a></li>
                        <li><a href="/contact">Contact Us</a></li>
                      </ul>
                    </div>
                  </div>

                  <div className="header-right-part1 d-flex align-items-center">

                    {deviceType === "desktop" && (<SearchDropdown />)}
                    {deviceType !== "desktop" && (
  <div
    style={{
      paddingLeft: "10px",
      marginLeft: "10px",
      cursor: "pointer",
    }}
    onClick={() => setOpenMobileSearch(true)}
  >
    <Icon.MagnifyingGlass size={22} color="#be1b12" />
  </div>
)}


                    {deviceType === "desktop" && (
                      <div
                        className="wptb-element"
                        style={{ paddingLeft: "10px", marginLeft: "10px" }}
                        onClick={() => navigate("/wishlist")}
                      >
                        <Icon.Heart size={20} color="#be1b12" />
                      </div>
                    )}

                    {deviceType === "desktop" && (
                      <div
                        className="wptb-element"
                        style={{ paddingLeft: "10px", marginLeft: "10px" }}
                        onClick={() => {
                          setIsCartOpen(true);
                          setShowRightMenu(true);
                          setIsProfileOpen(false);
                        }}
                      >
                        <div className="cart-icon position-relative">
                          <Icon.ShoppingCart size={20} color="#174a5b" />
                          <span className="position-absolute text-xs text-white bg-black w-4 h-4 d-flex justify-content-center rounded-circle"
                            style={{ right: "-6px", top: "-6px" }}
                          >
                            {cart?.length > 0
                              ? cart.reduce((sum, item) => sum + item.quantity, 0)
                              : 0}
                          </span>
                        </div>
                      </div>
                    )}

                    {isLoggedIn && (
                      <div
                        className="aside_open wptb-element"
                        style={{ paddingLeft: "10px", marginLeft: "10px" }}
                        onClick={() => {
                          setShowRightMenu(true);
                          setIsCartOpen(false);
                          setIsProfileOpen(true);
                        }}
                      >
                        <Icon.UserCircleGear size={20} color="black" />
                      </div>
                    )}

                    {!isLoggedIn && deviceType === "desktop" && (
                      <div
                        style={{ paddingLeft: "10px", marginLeft: "10px", cursor: "pointer" }}
                      >
                        <ButtonC
                          label="Log In"
                          bg="var(--cr-red-logo)"
                          onClick={() => dispatch(openLoginModal())}
                        />
                      </div>
                    )}

                    {!isLoggedIn && deviceType !== "desktop" && (
                      <div
                        style={{ paddingLeft: "10px", marginLeft: "10px", cursor: "pointer" }}
                        onClick={() => dispatch(openLoginModal())}
                      >
                        <Icon.User size={22} color="#be1b12" />
                      </div>
                    )}
                  </div>

                </div>
              </div>
            </div>
          </header>

         

          <div className="mr_menu" data-lenis-prevent>
            <button type="button" className="mr_menu_close">
              <i className="bi bi-x-lg"></i>
            </button>
            <h6>Menu</h6>
            <div className="mr_navmenu"></div>
          </div>

          <RightPanel
            showRightMenu={showRightMenu}
            isCart={isCartOpen}
            setShowRightMenu={setShowRightMenu}
          >
            {isProfileOpen && <Profile setIsProfileOpen={setShowRightMenu} />}

            {isCartOpen && (
              <CartDrawer
                cartItems={cartItems}
                onUpdateItem={handleUpdateItem}
                onRemoveItem={handleRemoveItem}
                onCheckout={handleCheckout}
                onClose={() => {
                  setShowRightMenu(false);
                  setIsCartOpen(false);
                }}
              />
            )}
          </RightPanel>
        </div>
      </div>
<MobileSearchDrawer
  open={openMobileSearch}
  onClose={() => setOpenMobileSearch(false)}
/>

    
    </div>
  );
}
